<div class="ui-segmented" role="radiogroup" [attr.aria-label]="ariaLabel()">
  @for (option of options(); track option.id) {
    <button
      class="ui-segmented-option"
      role="radio"
      type="button"
      [class.ui-segmented-option-active]="option.id === activeOptionId()"
      [disabled]="option.disabled === true"
      [attr.aria-checked]="option.id === activeOptionId() ? 'true' : 'false'"
      (click)="handleOptionSelected(option)"
    >
      {{ option.label }}
    </button>
  }
</div>
